import { render, staticRenderFns } from "./createbid.vue?vue&type=template&id=741939b9&scoped=true&"
import script from "./createbid.vue?vue&type=script&lang=js&"
export * from "./createbid.vue?vue&type=script&lang=js&"
import style0 from "./createbid.vue?vue&type=style&index=0&id=741939b9&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.6@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "741939b9",
  null
  
)

export default component.exports